
import {Component} from 'vue-property-decorator'
import { BaseMaintenanceSystemComponent } from '../base/BaseMixins'

@Component
export default class MaintenanceSystemName extends BaseMaintenanceSystemComponent {}
